import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CMSService } from '../services/cms.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-news-details',
  templateUrl: './news-details.component.html',
  styleUrls: ['./news-details.component.css'],
  standalone: true,
  imports: [CommonModule]
})
export class NewsDetailsComponent implements OnInit {

  articleId:number;
  activeRoute;
  article: any = {}; 
  
  constructor(private _activatedRoute: ActivatedRoute, private cmsService: CMSService,) { }

  ngOnInit() {
    this.activeRoute = this._activatedRoute.paramMap.subscribe({
        next: params => {
       
      this.articleId = parseInt(params.get('id'));
      var param = {
        id: this.articleId
      }

      this.cmsService.getArticleDetails(param).subscribe({
        next: (data: any) => {
        this.article = data; 
        
      }, error: (err: HttpErrorResponse) => {
        console.error(err);
      }});

    }});

  
  }

  ngOnDestroy() {
    this.activeRoute.unsubscribe();
  }

}
